import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus, FaBeer  } from "react-icons/cg";
import {
  DiJavascript1,
  DiReact,
  DiJava,
  DiMysql,
  DiPhp,
  DiLaravel,
 
} from "react-icons/di";
import {
  SiIntellijidea,
  SiFirebase,
  SiNextdotjs,
} from "react-icons/si";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
   
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 />
      </Col>
      
      <Col xs={4} md={2} className="tech-icons">
        <DiReact />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiPhp />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJava />
      </Col>
      
      <Col xs={4} md={2} className="tech-icons">
        <DiMysql />
      </Col>

      
     
    
    </Row>
  );
}

export default Techstack;
